'use client';

import { create } from 'zustand';

type HeaderLayoutStore = {
    // HeaderMainSection updates this flag from its container width and hover/pointer capabilities.
    // CSS keeps both Menu variants mounted; each overlay owner reads this to close itself when hidden.
    isDesktopMenu: boolean;
    setIsDesktopMenu: (isDesktopMenu: boolean) => void;
};

export const useHeaderLayoutStore = create<HeaderLayoutStore>(set => ({
    isDesktopMenu: false,
    setIsDesktopMenu: isDesktopMenu =>
        set(state => (state.isDesktopMenu === isDesktopMenu ? state : { isDesktopMenu })),
}));
